class EventHub {
  private static instance: EventHub;
  private events: Record<string, Function[]>;
  private constructor() {
    this.events = {};
  }
  public static getInstance() {
    if (!this.instance) {
      this.instance = new EventHub();
    }
    return this.instance;
  }
  public on(eventName: string, fn: Function) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(fn);
    return () => {
      this.off(eventName, fn);
    };
  }
  public off(eventName: string, fn: Function) {
    if (!this.events[eventName]) return;
    const index = this.events[eventName].findIndex((f) => f === fn);
    if (index === -1) return;
    this.events[eventName].splice(index, 1);
  }
  public emit(eventName: string, ...args: any[]) {
    if (!this.events[eventName]) return;
    this.events[eventName].forEach((fn) => fn(...args));
  }
}

export default EventHub;